import { Controller } from "@hotwired/stimulus"

// Auto-submits its form when a control inside it changes — so filters apply live as the staffer ticks,
// with no manual "Apply" button. Debounced so ticking several boxes in quick succession batches into one
// request (and Turbo lets the newest frame request supersede an in-flight one). The form targets the
// leaderboard Turbo frame and lives OUTSIDE it, so each submit re-renders only the ranked list — the open
// dropdown the staffer is ticking in stays put.
export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }

  connect() {
    this.onChange = () => {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => this.element.requestSubmit(), this.delayValue)
    }
    this.element.addEventListener("change", this.onChange)
  }

  disconnect() {
    clearTimeout(this.timer)
    this.element.removeEventListener("change", this.onChange)
  }
}
